import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import styles from "./WhatsappWidgetSteps.module.css";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import { HOST_URL } from "../api/Api";
import Axios from "axios";

// Import all step components
import Spining from "../../UI/Spining/Spining";
import WhatsappWidgetStep1 from "./WhatsappWidgetStep1";
import WhatsappWidgetDataStep2 from "./WhatsappWidgetDataStep2";
import WhatsappWidgetStep3 from "./WhatsappWidgetStep3";
import WhatsappWidgetStep4 from "./WhatsappWidgetStep4";
// import { handleUserLog } from "../../Utils/Utils";

const StepForm = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const location = useLocation();

  const [step, setStep] = useState(location.state?.initialStep || 1);
  const [accountStatus, setAccountStatus] = useState(null);
  const [generatedScript, setGeneratedScript] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [widgetId, setWidgetId] = useState(null); // <-- store API ID
  const [loading, setLoading] = useState(true);   // ✅ new state

  // Fetch API ID and account status
  useEffect(() => {
    const fetchAccountStatus = async () => {
      try {
        const params = {
          user_id: userId,
          token: userToken,
          method: "retrieve",
        };

        const { data } = await Axios.post(`${HOST_URL}/wp_profile.php`, params);

        if (data.success && data.data.length > 0) {
          const apiId = data.data[0].id; // ✅ This is the widget ID
          setWidgetId(apiId);

          const status = data.data[0]?.status === 1 ? "live" : "pending";
          setAccountStatus(status);

          if (status === "live") setStep(2); // auto-advance if live
        } else {
          // ✅ no widget found
          setAccountStatus("new");
        }
      } catch (error) {
        console.log(error);
        setAccountStatus("new"); // fallback to onboarding form
      } finally {
        setLoading(false); // ✅ stop loader
      }
    };

    fetchAccountStatus();
  }, [userId, userToken]);

  const nextStep = () => {
    if (accountStatus !== "live") {
      setShowPopup(true);
      return;
    }
    if (step < 4) setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  // Render the correct step component
  const renderStepContent = () => {
    if (loading) {
      return <Spining />;
    }

    switch (step) {
      case 1:
        return <WhatsappWidgetStep1 match={{ params: { id: widgetId } }} />;
      case 2:
        return (
          <WhatsappWidgetDataStep2
            match={{ params: { id: widgetId } }}
            setGeneratedScript={setGeneratedScript}
          />
        );
      case 3:
        return (
          <WhatsappWidgetStep3
            match={{ params: { id: widgetId } }}
            responsedata={generatedScript}
          />
        );
      case 4:
        return <WhatsappWidgetStep4 match={{ params: { id: widgetId } }} />;
      default:
        return <WhatsappWidgetStep1 match={{ params: { id: widgetId } }} />;
    }
  };

  return (
    <DashboardLayout>
      <div className="container-fluid m-2">
        <h5>Whatsapp Widget Setup</h5>

        {/* Progress Steps */}
        <div className={`card shadow-sm mb-4 p-4 ${styles.fullCard}`}>
          <div className={`d-flex justify-content-between ${styles.stepsProgress}`}>
            {[1, 2, 3, 4].map((num, index) => (
              <div key={num} className={styles.stepItem}>
                <div
                  className={`${styles.circle} ${step >= num ? styles.active : ""}`}
                  onClick={() => setStep(num)}
                >
                  {num}
                </div>
                {index < 3 && (
                  <div
                    className={`${styles.line} ${step > num ? styles.activeLine : ""}`}
                  ></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Step Content */}
        <div className={`card shadow-sm ${styles.contentCard}`}>
          {renderStepContent()}

          <div className="d-flex justify-content-between mt-4 mb-4">
            <button
              className={`btn ${styles.backBtn}`}
              onClick={prevStep}
              disabled={step === 1}
            >
              <FaArrowLeft className="me-2" />
              Previous
            </button>

            <button
              className={`btn ${styles.continueBtn}`}
              onClick={nextStep}
              disabled={step === 4}
            >
              Continue
              <FaArrowRight className="ms-2" />
            </button>
          </div>
        </div>
      </div>

      {/* Bootstrap Modal */}
      {showPopup && (
        <div
          className="modal d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content  p-4"
              style={{
                borderRadius: "1rem",
                maxWidth: "400px",
                margin: "0 auto",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              }}
            >
              {/* Icon */}
              <div className="d-flex justify-content-center mb-4">
                <div
                  style={{
                    backgroundColor: "#d4f5e2",
                    padding: "12px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    style={{ width: "32px", height: "32px", color: "#38e07b" }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                    />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h2 className="fw-bold text-dark mb-2" style={{ fontSize: "1.2rem",textAlign: "center" }}>
                WhatsApp Onboarding Pending
              </h2>

              {/* Description */}
              <p className="mb-4" style={{ fontSize: "0.95rem" }}>
                To create a widget, you must first complete the WhatsApp onboarding
                process. This ensures your account is properly configured and ready to
                integrate with our services.
              </p>

              {/* Buttons */}
              <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center">
                <button
                  className="btn btn-light btn-sm w-100 w-sm-auto border"
                  style={{ fontWeight: "600" }}
                  onClick={() => setShowPopup(false)}
                >
                  Close
                </button>
                <button
                  className="btn btn-sm text-white w-100 w-sm-auto"
                  style={{
                    backgroundColor: "#38e07b",
                    fontWeight: "600",
                  }}
                  onClick={() => {
                    setShowPopup(false);
                    window.location.href = `/dashboard/whatsapp-widget-steps/${widgetId}`;
                  }}
                >
                  Start Onboarding
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default StepForm;
